var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},_vm._l((_vm.content),function(item,index){return _c('accordion-item',{key:index,attrs:{"id":index,"item":item,"activeId":_vm.activeId,"toggleAccordion":_vm.toggleAccordion}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }